var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var StatisticsController = /** @class */ (function () {
    function StatisticsController() {
    }
    /*****************************************************************************************************
        * Is using route "api/statistics/group/users" and http method "POST" to call the back-end.
    
        * @param {GroupUserFilter} filter
        * @returns {EventDownloadDto}
    ******************************************************************************************************/
    StatisticsController.PostGroupUsers = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/statistics/group/users", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/statistics/group/users/quiz" and http method "POST" to call the back-end.
    
        * @param {GroupUserFilter} filter
        * @returns {GroupUserQuizStatistics}
    ******************************************************************************************************/
    StatisticsController.PostGroupUsersQuiz = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/statistics/group/users/quiz", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/statistics/filteredEvents" and http method "POST" to call the back-end.
    Returns filtered events with payload.
    
        * @param {EventFilterDto} filter  Filter to filter events by group and time
        * @returns {EventDownloadDto[]}
    ******************************************************************************************************/
    StatisticsController.GetFilteredEvents = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/statistics/filteredEvents", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/statistics/groups/count" and http method "POST" to call the back-end.
    
        * @param {BaseFilterDto} filter
        * @returns {GroupStatsDto[]}
    ******************************************************************************************************/
    StatisticsController.GetGroupsCount = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/statistics/groups/count", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/statistics/groups" and http method "POST" to call the back-end.
    
        * @param {BaseFilterDto} filter
        * @returns {GroupStatsDto[]}
    ******************************************************************************************************/
    StatisticsController.GetGroupsStats = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/statistics/groups", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/statistics/posts" and http method "POST" to call the back-end.
    
        * @param {PostStatFilter} filter
        * @returns {PostStatsDto[]}
    ******************************************************************************************************/
    StatisticsController.GetPostStats = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/statistics/posts", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/statistics/group/posts" and http method "POST" to call the back-end.
    
        * @param {PostStatFilter} filter
        * @returns {PostGroupStatsDto[]}
    ******************************************************************************************************/
    StatisticsController.GetGroupPostStats = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/statistics/group/posts", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/statistics/group/logins" and http method "POST" to call the back-end.
    
        * @param {EventFilterDto} filter
        * @returns {GroupLoginStatDto[]}
    ******************************************************************************************************/
    StatisticsController.GetGroupLogins = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/statistics/group/logins", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/statistics/group/loginsSum" and http method "POST" to call the back-end.
    
        * @param {EventFilterDto} filter
        * @returns {GroupLoginStatDto[]}
    ******************************************************************************************************/
    StatisticsController.GetGroupLoginsSum = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/statistics/group/loginsSum", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/statistics/post/topReactions" and http method "POST" to call the back-end.
    
        * @param {ContentPostFilterDto} filter
        * @returns {PostInteractionStatDataDto[]}
    ******************************************************************************************************/
    StatisticsController.GetPostsWithTopReactions = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/statistics/post/topReactions", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/statistics/post/createdHistory" and http method "POST" to call the back-end.
    
        * @param {EventFilterDto} filter
        * @returns {PostCreatedStatDto[]}
    ******************************************************************************************************/
    StatisticsController.GetPostCreatedHistory = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/statistics/post/createdHistory", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/statistics/training/course" and http method "POST" to call the back-end.
    
        * @param {TrainingFilterDto} filter
        * @returns {TrainingResult[]}
    ******************************************************************************************************/
    StatisticsController.GetTrainingStats = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/statistics/training/course", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/statistics/training/course/excel" and http method "POST" to call the back-end.
    
        * @param {TrainingFilterDto} filter
        * @returns {LinkDto}
    ******************************************************************************************************/
    StatisticsController.GetTrainingStatsExcel = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/statistics/training/course/excel", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    return StatisticsController;
}());
export { StatisticsController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=StatisticsController.js.map